import React, { useMemo, useState } from 'react';
import { ColDef } from 'ag-grid-community';
import { Segment } from 'semantic-ui-react';
import { Error, Table } from '@app/shared';
import { AuthorisationStatus, useGetAccountAuthorisations } from '@app/sdk';
import { toCurrency, toFormattedDate } from '@app/utilities';
import { useAccountIdContext } from '../AccountIdContext';
import './AccountAuthorisationsSearch.css';

export default function AccountAuthorisationsSearch() {
  const { accountId } = useAccountIdContext();
  const [status, setStatus] = useState<AuthorisationStatus>();
  const { data: authorisations, isLoading, error } = useGetAccountAuthorisations({ accountId, status });

  const columnDefs = useMemo<ColDef[]>(
    () => [
      { field: 'status', headerName: 'Status' },
      { field: 'authorisationId', headerName: 'Authorisation ID' },
      {
        field: 'authorisationDate',
        headerName: 'Authorisation Date',
        valueFormatter: (params) => (params.value ? toFormattedDate(params.value, 'yyyy-MM-dd HH:mm:ss') : ''),
      },
      { field: 'description', headerName: 'Description' },
      {
        field: 'amount.value',
        headerName: 'Amount',
        valueFormatter: (params) => (params.value == null ? '' : toCurrency(params.value)),
      },
      {
        field: 'remainingFloat',
        headerName: 'Remaining Float',
        valueFormatter: (params) => (params.value == null ? '' : toCurrency(params.value)),
      },
      {
        field: 'expiryDate',
        headerName: 'Expiry Date',
        valueFormatter: (params) => (params.value ? toFormattedDate(params.value, 'yyyy-MM-dd HH:mm:ss') : ''),
      },
      { field: 'declineReason', headerName: 'Decline Reason' },
    ],
    [],
  );

  return (
    <Segment style={{ height: '430px' }}>
      <div className="account-authorisations-search__header">
        <h2 className="ui header account-authorisations-search__title">
          <span>Account Authorisations(Search)</span>
          {isLoading && <div className="ui active inline loader" />}
        </h2>
        <div className="field account-authorisations-search__status-filter">
          <label htmlFor="authorisation-status">Status</label>
          <select
            id="authorisation-status"
            className="ui selection dropdown"
            onChange={(event) =>
              setStatus(
                event.target.value === 'Pending' || event.target.value === 'Declined' ? event.target.value : undefined,
              )
            }
            value={status ?? ''}>
            <option value="">All</option>
            <option value="Pending">Pending</option>
            <option value="Declined">Declined</option>
          </select>
        </div>
      </div>
      <Error error={error} />
      {!error && !isLoading && (!authorisations || authorisations.length === 0) && <div>No authorisations found</div>}
      {!error && !isLoading && !!authorisations?.length && (
        <div style={{ height: '300px' }}>
          <Table items={authorisations} columnDefs={columnDefs} />
        </div>
      )}
    </Segment>
  );
}
